import { Button } from "@evidenceb/athena-common/design-system/Button";
import type { ErrorContent } from "../../../interfaces/Error";

import "./Popup.scss";

interface PopupProps {
  content: Omit<ErrorContent, "title">;
  action?: () => void;
  close?: () => void;
}

const Popup = ({ content, action, close }: PopupProps) => {
  const callToAction = () => {
    action?.();
    close?.();
  };

  if (!content.text && !content.btn) return null;

  return (
    <div className="error-popup">
      {content.text && (
        <div className="error-popup__content">{content.text}</div>
      )}
      <div className="alert-buttons">
        {content.btn && (
          <>
            {content.btn.cancel && (
              <Button variant="secondary" label="Cancel" onClick={close} />
            )}
            <Button
              variant="primary"
              label={content!.btn.label}
              onClick={callToAction}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Popup;
